export const SAMPLE_REPORT_SUCCESS = "SAMPLE_REPORT_SUCCESS";
